import { useNavigate } from "react-router-dom";
import { useI18n } from "../../utils/translate/i18n/useI18n";
import { isAuthenticated } from "../../auth/auth";
import "./footer.scss";

export default function Footer() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__inner">
        <span className="footer__copy">
          <span>&copy; {year}</span>
          <span className="footer__brand">Świat Słuchu</span>
          <span className="footer__tagline">&mdash; {t("Narzędzie do wstępnej oceny słuchu.")}</span>
        </span>

        <span className="footer__author">{t("Autor")}: Adam Borkowski</span>

        {isAuthenticated() && (
          <nav className="footer__links" aria-label={t("Linki prawne")}>
            <button
              type="button"
              className="footer__link footer__link--button"
              onClick={() => navigate("/privacy-policy")}
            >
              {t("Polityka prywatności")}
            </button>
          </nav>
        )}
      </div>
    </footer>
  );
}
